import type { CSSProperties, ReactElement } from "react";
import type { Site } from "@/types/sites";
import { useEffect, useState } from "react";
import Script from "next/script";

export const Analytics = ({ site }: { site: Site | null }): ReactElement => {
    const siteAttrs = site?.attributes;
    const googleTagManagerContainerId = siteAttrs?.googleTagManagerContainerId;
    const googleOptimizeContainerId = siteAttrs?.googleOptimizeContainerId;
    const iframeStyles: CSSProperties = {
        display: "none",
        visibility: "hidden",
    };

    const [shouldFireGtm, setShouldFireGtm] = useState(true);

    useEffect(() => {
        if (typeof window !== "undefined") {
            setShouldFireGtm(!window.willRedirectionOccurByVWO);
        }
    }, []);
    useEffect(() => {
        googleTagManagerContainerId && prepWindowForGtm();
    }, [googleTagManagerContainerId]);


    return (<>
        {googleOptimizeContainerId && (
            <Script
                id="googleoptimize"
                src={`https://www.googleoptimize.com/optimize.js?id=${encodeURIComponent(
                    googleOptimizeContainerId
                )}`}
                strategy="afterInteractive"
            />
        )}
        {shouldFireGtm && googleTagManagerContainerId && (
            <>
                <Script
                    id="googletagmanager"
                    src={`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
                        googleTagManagerContainerId
                    )}`}
                    strategy="afterInteractive"
                />

                <noscript>
                    <iframe
                        id="googletagmanager-noscript"
                        src={`https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(
                            googleTagManagerContainerId
                        )}`}
                        height="0"
                        width="0"
                        style={iframeStyles}
                    />
                </noscript>
            </>
        )}
    </>);
};

const prepWindowForGtm = (): void => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "gtm.start": Date.now(),
        event: "gtm.js",
    });
};
